import React, { useState, useEffect } from "react";
import "./home.css";
import { tabName } from "../../utils/constants";
import WarrantEducation from "./tabs/warrantEduction";
import WarrantStatistics from "./tabs/warrantStatistics";
import MarketNews from "./tabs/marketNews";
import WarrantTool from "./tabs/warrantTools";
import { Link, useHistory } from "react-router-dom";
import LangContext from "../../components/common/context/lang-context";
import { useContext } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import API from "../../utils/apiCalling";
import { config } from "../../utils/apiUrl";
import { languageText } from "../../languageText/home";

const Home = () => {

  const history = useHistory()
  const api = new API();
  const [activeTab, setActiveTab] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState();
  const [count, setcount] = useState(11);
  const [open11, setopen11] = useState(true);
  const langContext = useContext(LangContext);
  const [popupData, setPopupData] = useState([]);
  const [popupDataMobile, setPopupDataMobile] = useState([]);
  const [siteLang , setSiteLang] = useState("")
  const [popUp , setPopUp] = useState("")
  const [popupHomepage , setPopupHomepage] = useState({})
  const [disclaimer, setDisclaimer] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
    var siteLanguage = $.cookie('applang');
    setSiteLang(siteLanguage)
    if(siteLanguage == "eng"){
      document.querySelector("body").classList.add("eng")
    }else{
      document.querySelector("body").classList.remove("eng")
    }
    var activeTabVal = window.location.href.split("home?")[1]
    if(activeTabVal == "dwstat"){
      setActiveTab('Warrant statistics')
    }
    else if(activeTabVal == "dwedu"){
      setActiveTab('Warrant education')
    }
    else if(activeTabVal == "dwnews"){
      setActiveTab('Market news')
    }
    else{
      setActiveTab('Warrant tools')
    }
  }, []);

  const isActive = (tab) => {
    if (activeTab === tab) {
      return "active";
    }
    return "";
  };

  useEffect(() => {
    updatePopuptime();
    // updateDisclaimertime()
    return () => {};
  }, []);

  useEffect(() => {
    getHomePopup();
    getPopup()
    getPopupHomepageJSON()
  }, []);
  const getPopup = async ()=>{
    let popUp = await api.get(config.homePopup, true);
    setPopUp(popUp)
  }

  const getPopupHomepageJSON = async ()=>{
    let popUp = await api.get(config.PopupHomepageJSON, true);
    console.log(">>>>>>>>>>>>>>>run here:", popUp)
    setPopupHomepage(popUp)
  }

  const getHomePopup = async () => {
    let homePopupResult = await api.get(config.homeBanner, true);
    let homeMainBanner = homePopupResult.homedata;
    let items = []; 
    let itemss = [];
    if (homeMainBanner?.length > 0) {
      for (let i = 0; i < homeMainBanner.length; i += 2) {
        let advImgData = await api.get(config.advImgData, true, {
          topbanner: homeMainBanner[i].id,
        });
        items.push({
          imgSrc: advImgData,
          link: homeMainBanner[i].link,
        });
      }
      setPopupData(items);
      for (let j = 1; j < homeMainBanner.length; j += 2) {
        let advImgData = await api.get(config.advImgData, true, {
          topbanner: homeMainBanner[j].id,
        });
        itemss.push({
          imgSrc: advImgData,
          link: homeMainBanner[j].link,
        });
      }
      setPopupDataMobile(itemss);
    }
  };

  const updatePopuptime = () => {
    try {
      var cookieData = $.cookie('lightbox0001');
      if(cookieData == 0){
        setopen11(false)
      }else{
        var c = 11;
        var ninterval = setInterval(() => {
          setcount(c);
          c--;
          if (c === 0) {
            clearInterval(ninterval);
            setopen11(false);
          }
        }, 1000);
      }
    } catch (error) {}
  };
  
  const bannerCookie = () => {
    $.cookie('lightbox0001', "0", {expires: 365});
    setopen11(false)
  }
  // const updateDisclaimertime = () => {
  //   try {
  //     var cookieData = $.cookie('Disclaimertime');
  //     console.log(cookieData)
  //     if(cookieData == 0){
  //       setDisclaimer(false)
  //     }else{
  //       setDisclaimer(true)
  //     }
  //   } catch (error) {}
  // };
  const renderTab = () => {
    switch (activeTab) {
      case tabName.warrantTools:
        return <WarrantTool />;
        break;
      case tabName.warrantEducation:
        return <WarrantEducation />;
        break;
      case tabName.warrantStatistics:
        return <WarrantStatistics />;
        break;
      case tabName.marketNews:
        return <MarketNews />;
        break;
      default:
        return null;
        break;
    }
  };

  const settings = {
    autoplay: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  };
  const settingss = {
    autoplay: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
  };
  const closeDisclaimer = () => {
    setDisclaimer(false)
    // $.cookie('Disclaimertime', "0", {expires: 7});
    document.querySelector("body").classList.remove("noScroll")
  }
  return (
    <>
      <div id="home">
        <Slider {...settings} className="show-desk">
          {popupData &&
            popupData.map((data, index) => {
              return (
                <div className="gallery-item" key={index}>
                  <a
                    className="homeimg-achor home_banner1"
                    target="_blank"
                    href={data.link}
                  >
                    <img
                      className="hiddn_mob"
                      style={{ width: "100%", marginTop: 45 }}
                      src={data.imgSrc}
                    />
                  </a>
                </div>
              );
            })}
        </Slider>
        <Slider {...settingss} className="show-mob">
          {popupDataMobile &&
            popupDataMobile.map((data, index) => {
              return (
                <div className="gallery-item" key={index}>
                  <a
                    className="homeimg-achor home_banner1"
                    target="_blank"
                    href={data.link}
                  >
                    <img
                      className="hiddn_mob"
                      style={{ width: "100%", marginTop: 70 }}
                      src={data.imgSrc}
                    />
                  </a>
                </div>
              );
            })}
        </Slider>
        <nav className="tabnav container-fluid">
          <div className="row">
            <div className="col-md-3 col-xs-3">
              <div
                onClick={() => {
                  setActiveTab(tabName.warrantTools)
                  // history.push("/home")
                  window.history.replaceState(null, "", "/home")
                }}
                className={`tabnav-item tabnav-item-dwtool ${isActive(
                  tabName.warrantTools
                )}`}
                data-value="dwtool"
              >
                <div className="tabnav-img" />
                <h2 className="tabnav-htxt">
                  {siteLang == "eng" ? languageText.toolTitleEn : languageText.toolTitle}
                </h2>
                <div className="tabnav-txt visible-md visible-lg">
                  {siteLang == "eng" ? languageText.toolParaEn : languageText.toolPara}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-xs-3">
              <div
                onClick={() => {
                  setActiveTab(tabName.warrantStatistics)
                  // history.push("/home?dwstat")
                  window.history.replaceState(null, "", "/home?dwstat")
                }}
                className={`tabnav-item tabnav-item-dwstat ${isActive(
                  tabName.warrantStatistics
                )}`}
                data-value="dwstat"
              >
                <div className="tabnav-img" />
                <h2 className="tabnav-htxt">
                  {siteLang == "eng" ? languageText.statTitleEn : languageText.statTitle}
                </h2>
                <div className="tabnav-txt visible-md visible-lg">
                  {siteLang == "eng" ? languageText.statParaEn : languageText.statPara}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-xs-3">
              <div
                onClick={() => {
                  setActiveTab(tabName.warrantEducation)
                  // history.push("/home?dwedu")
                  window.history.replaceState(null, "", "/home?dwedu")
                }}
                className={`tabnav-item tabnav-item-dwedu ${isActive(
                  tabName.warrantEducation
                )}`}
                data-value="dwedu"
              >
                <div className="tabnav-img" />
                <h2 className="tabnav-htxt">
                  {siteLang == "eng" ? languageText.eduTitleEn : languageText.eduTitle}
                </h2>
                <div className="tabnav-txt visible-md visible-lg">
                  {siteLang == "eng" ? languageText.eduParaEn : languageText.eduPara}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-xs-3">
              <div
                onClick={() => {
                  setActiveTab(tabName.marketNews)
                  // history.push("/home?dwnews")
                  window.history.replaceState(null, "", "/home?dwnews")
                }}
                className={`tabnav-item tabnav-item-dwnews ${isActive(
                  tabName.marketNews
                )}`}
                data-value="dwnews"
              >
                <div className="tabnav-img" />
                <h2 className="tabnav-htxt">
                  {siteLang == "eng" ? languageText.newsTitleEn : languageText.newsTitle}
                </h2>
                <div className="tabnav-txt visible-md visible-lg">
                  {siteLang == "eng" ? languageText.newsParaEn : languageText.newsPara}
                </div>
              </div>
            </div>
          </div>
          <div className="visible-xs visible-sm">
            <p className={activeTab == "Warrant tools" ? "nav-dtxt show" : "nav-dtxt"} data-value="dwtool">{siteLang == "eng" ? languageText.toolParaEn : languageText.toolPara}</p>
            <p className={activeTab == "Warrant statistics" ? "nav-dtxt show" : "nav-dtxt"} data-value="dwstat">{siteLang == "eng" ? languageText.statParaEn : languageText.statPara}</p>
            <p className={activeTab == "Warrant education" ? "nav-dtxt show" : "nav-dtxt"} data-value="dwedu">{siteLang == "eng" ? languageText.eduParaEn : languageText.eduPara}</p>
            <p className={activeTab == "Market news" ? "nav-dtxt show" : "nav-dtxt"} data-value="dwnews">{siteLang == "eng" ? languageText.newsParaEn : languageText.newsPara}</p>
          </div>
        </nav>
        {renderTab()}

        <div className="banner">
          <div className="banner-wapper container-fluid">
            <Link to="/education/whydw28">
              <img
                className="banner-img"
                src={siteLang == "eng" ? "/img/home/19072022_Website-Brand_en.jpg" : "/img/home/19072022_Website-Brand_th.jpg"}
              />
            </Link>
          </div>
        </div>
      </div>

      {open11 && <div id="lightbox" >
        <div onClick={()=>setopen11(false)}>
          <div className="inner-area">
            <a href="javascript:void(0)" onClick={()=>setopen11(false)} className="btn-close"></a>
            <div className="countdown-txt">
              Closes after <span id="ctlbl">{count}</span> seconds...
            </div>
            <a id="lightbox_link" href={popupHomepage.link} target="_blank">
              <img src={popUp} alt="Banner Img" />
            </a>
            <a href="javascript:void(0)" className="noshow text-bold text-black" onClick={bannerCookie} >
              Don't show again
            </a>
          </div>
        </div>
      </div>}
      {disclaimer && <div id="disclaimer" className="disclaimer-overlay" style={{overflowY: 'scroll',zIndex: 2008}}>
        <div className="disclaimer-overlay-inner" style={{width:'65%'}}>
          <div style={{textAlign: 'center', padding: '10px'}}>
            <div className="popupbox-content"  style={{height:'65vh'}}>
              <div className="disclaimer-page-header" style={{textAlign: 'left'}}>
                <h1 className="small"  style={{margin:'3px 0px'}}>แจ้งเตือน</h1>
              </div>
              <p style={{textAlign: 'left'}}>
              ทางบริษัทได้รับแจ้งว่ามีการแอบอ้างนำชื่อของ Macquarie และพนักงานของบริษัท เพื่อใช้ในการหลอกลวงเงินจากนักลงทุน จึงขอแจ้งเตือนว่า Macquarie ไม่มีการติดต่อขอให้นักลงทุนเปิดบัญชีหรือโอนเงินใด ๆ ทั้งสิ้น
              </p>
              <div className="popupbox-content" style={{height:'auto',overflowY: 'hidden',border:'0',padding: '0px'}}>
              <div style={{marginBottom:'10px'}}>แพลตฟอร์มโซเชียลมีเดียที่ธุรกิจของ Macquarie ใช้อยู่ ได้แก่ LinkedIn, Facebook, X, Instagram, YouTube และสำหรับแพลตฟอร์มโซเชียลมีเดียเฉพาะของ Macquarie ประเทศไทย มีเพียง Facebook (Macquarie DW28-Thaidw) และ Line (@thaidw) เท่านั้น</div>
              ทั้งนี้ ในกรณีที่ท่านพบเห็นโฆษณา หรือได้รับสายโทรศัพท์ หรือได้รับการเชิญชวนเข้าร่วมกลุ่ม Chat จากบัญชี หรือบุคคลอื่นใดที่แอบอ้างว่าเกี่ยวข้องกับ Macquarie หรือเป็นตัวแทนของ Macquarie กรุณาโปรดอย่าตอบกลับ หรือแชร์ข้อมูลทางการเงินส่วนบุคคล และโปรดตรวจสอบรายชื่อธุรกิจที่ไม่ได้รับอนุญาตหรือไม่ได้ลงทะเบียน ซึ่งถูกร้องเรียนและตรวจสอบแล้ว ที่เว็บไซต์ของสำนักงาน ก.ล.ต. หัวข้อ SCAM CENTER Investor Alert ที่ 
              <a target="_blank"  href="https://market.sec.or.th/public/idisc/th/InvestorAlert"> รายชื่อผู้ที่มิใช่ผู้ประกอบธุรกิจภายใต้การกำกับดูแลของ ก.ล.ต. </a> หากท่านเชื่อว่าท่านได้ตกเป็นเหยื่อของการหลอกลวงลงทุนใด ๆ โปรดติดต่อสายด่วนศูนย์ปฏิบัติการแก้ไขปัญหาอาชญากรรมออนไลน์ (AOC) ที่เบอร์ 1441 หรือแจ้งไปยัง 
              <a target="_blank"  href="https://www.thaipoliceonline.go.th/"> ศูนย์ปราบปรามอาชญากรรมทางเทคโนโลยีสารสนเทศ สำนักงานตำรวจแห่งชาติ </a> หากท่านต้องการนำส่งข้อมูลเกี่ยวกับแพลตฟอร์มโซเชียลมีเดียที่คาดว่าเป็นการหลอกลวงลงทุน โปรดติดต่อสายด่วนรายงานการหลอกลวงลงทุนของสำนักงาน ก.ล.ต. ที่เบอร์ 1207 (ต่อ 22) หรือแจ้งผ่านทาง 
              <a target="_blank"  href="https://www.sec.or.th/TH/Pages/ScamAlert.aspx"> SEC Thai ScamAlert </a> นอกจากนี้ ท่านยังสามารถติดต่อ 
              <a   href="mailto:globalinvestigations@macquarie.com"> ทีม Global Security ของ Macquarie </a>
               หรือติดต่อที่ทำการของ Macquarie ประเทศไทย ที่เบอร์
              </div>
              <div className="disclaimer-page-header" style={{textAlign: 'left'}}>
                <h1 className="small" style={{margin:'2px 0px'}}>เงื่อนไขการใช้งาน และนโยบายความเป็นส่วนตัว</h1>
              </div>
              <p style={{textAlign: 'left'}}>
              ท่านต้องยอมรับเงื่อนไขการใช้งาน และนโยบายความเป็นส่วนตัวเพื่อการดำเนินการต่อ
              </p>
              เว็ปไซต์นี้จัดทำโดยบริษัทหลักทรัพย์ แมคควอรี (ประเทศไทย) จำกัด (Macquarie Securities (Thailand) Limited) ("บริษัทฯ") (เลขทะเบียนบริษัท 0105539119915) ผู้ได้รับอนุญาตประกอบธุรกิจนายหน้าซื้อขายหลักทรัพย์ ภายใต้พระราชบัญญัติหลักทรัพย์และตลาดหลักทรัพย์ พ.ศ. 2535 และได้รับความเห็นชอบอนุญาตให้เป็นผู้ออกและเสนอขายใบสำคัญแสดงสิทธิอนุพันธ์ในตลาดหลักทรัพย์แห่งประเทศไทย จากสำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ (“สำนักงาน ก.ล.ต.”) ไม่ว่าจะด้วยเหตุใดก็ตาม ห้ามผู้ใดทำซ้ำ คัดลอก แปล หรือ แจกจ่าย ข้อมูล และเนื้อหาของเว็ปไซต์นี้
              <br /><br />
              ข้อมูลและเนื้อหาในเว็ปไซต์นี้มีไว้สำหรับผู้มีถิ่นที่อยู่ในประเทศไทยเท่านั้น มิได้จัดเตรียมให้บุคคลอเมริกัน (U.S. Person) หรือบุคคลของประเทศอื่นใด โดยข้อมูลต่างๆ ในที่นี้รวมถึงตัวอย่างการคำนวณต่างๆ มีวัตถุประสงค์เพื่อเป็นข้อมูลประกอบการศึกษาเท่านั้น มิใช่เพื่อประกอบการเสนอขาย ชักชวน หรือแนะนำให้ลงทุนแต่อย่างใด โดยข้อมูลที่ปรากฎในเว็ปไซต์นี้ถูกนำเสนอในลักษณะตามสภาพที่บริษัทฯได้รับ จากแหล่งข้อมูลที่มีความน่าเชื่อถือ บริษัทฯ ไม่ได้ให้การรับประกันหรือการรับรองใดๆไม่ว่าจะโดยชัดแจ้งหรือโดยปริยายในความถูกต้อง แท้จริง ครบถ้วน หรือความน่าเชื่อถือได้ของข้อมูลดังกล่าว นอกจากนี้บริษัทขอปฏิเสธที่จะรับประกันไม่ว่าโดยชัดแจ้งหรือโดยปริยายว่าเว็ปไซต์นี้จะตอบสนองวัตถุประสงค์ในการใช้ของท่าน รวมถึงไม่ขอรับรองว่าเว็ปไซต์จะทำงานได้อย่างถูกต้องหรือตรงตามวัตถุประสงค์ตามที่ได้กำหนดไว้ ดังนั้น บริษัทฯ จะไม่รับผิดชอบในความเสียหายใดๆ ซึ่งรวมตลอดถึงและไม่จำกัดเพียงความสูญเสียใดๆที่เกิดขึ้นไม่ว่าจะโดยตรงหรือโดยอ้อมที่เกิดขึ้นจากการใช้เว็ปไซต์นี้
              <br /><br />
              บริษัทฯ เป็นผู้ออกใบสำคัญแสดงสิทธิอนุพันธ์ของแมคควอรี และมี Macquarie Financial Limited ("MFL") เป็นผู้ค้ำประกันการชำระหนี้ ดังนั้น การอ้างอิงข้อมูลต่างๆเกี่ยวกับแมคควอรีจะหมายถึงบริษัทฯ ("MACQ") เท่านั้น บุคคลหรือนิติบุคคลอื่นใดถือเป็นตัวกลางในการทำหน้าที่เป็นนายหน้าซื้อขายหรือผู้กระจายใบสำคัญแสดงสิทธิอนุพันธ์ของแมคควอรีเท่านั้น นอกจากนี้ บริษัทฯ มิได้ให้บริการรับฝากเงินและ/หรือดำเนินธุรกิจการธนาคารในประเทศไทยแต่อย่างใด และความรับผิดชอบต่างๆ ของบริษัทฯ มิได้แสดงถึงการบริการรับฝากเงิน/กู้เงิน ที่สัมพันธ์กับ Macquarie Bank Limited (เลขทะเบียนบริษัท ABN 46 008 583 542) การลงทุนมีความเสี่ยง อาจทำให้สูญเสียเงินต้นทั้งหมดและรายได้ รวมถึงความล่าช้าในการชำระเงินคืน ทั้งนี้ Macquarie Bank Limited มิได้ให้การรับประกันหรือรับรองความรับผิดชอบของบริษัทฯ แต่อย่างใด
              <br /><br />
              การเปิดเผยข้อมูลของบริษัทจดทะเบียน ถ้าระบุไว้ในเว็บไซต์นี้ นักลงทุนสามารถอ่านรายละเอียดเพิ่มเติมได้ที่  <a target="_blank"  href="http://www.macquarie.com/disclosures">www.macquarie.com/disclosures</a>
              <br /><br />
              สำหรับข้อมูลเพิ่มเติมเกี่ยวกับคำเตือนบนโซเชียลมีเดีย นักลงทุนสามารถอ่านรายละเอียดเพิ่มเติมได้ที่  <a target="_blank"  href="http://www.macquarie.com/about/disclosures/social-media-disclaimer">www.macquarie.com/about/disclosures/social-media-disclaimer</a>
              <br /><br />
              นักลงทุนสามารถอ่านนโยบายความเป็นส่วนตัวเกี่ยวกับการเก็บรวบรวม ใช้ และการจัดการข้อมูลส่วนบุคคลของท่านได้ที่&nbsp;<a target="_blank"  href="https://www.thaidw.com/about/privacypolicy">https://www.thaidw.com/about/privacypolicy</a> และข้อกำหนด เงื่อนไข และคำเตือนอื่นๆเพิ่มเติมได้ที่&nbsp;<a target="_blank"  href="https://www.thaidw.com/about/disclaimer">https://www.thaidw.com/about/disclaimer</a> 
            </div>
            <div onClick={closeDisclaimer} className="btn btn-primary close-btn" style={{margin: '10px auto', fontSize: '24px', minWidth: '190px'}}>ตกลง</div>
          </div>
        </div>
        </div>}
    </>
  );
};

export default Home;
